import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import PythonEditor from '../../pages/Chat/PythonEditor';
import config from '../../config';

const PythonEditor_Modal = ({ code }) => {
    const [modal_standard, setmodal_standard] = useState(false);
        function pythoncode_Modal() {
            setmodal_standard(!modal_standard);
        }
  return (
    <>
    <Button className="btn rounded-pill" color="primary" id="pythoncode" onClick={() => pythoncode_Modal()}> <i className="bx bxl-python"></i></Button>
    <UncontrolledTooltip
        placement="left"
        target="pythoncode"
        className="leftmore"
        id="pythoncode_tooltip"
    >
        {config.tool_tip.Phython_Editor}
    </UncontrolledTooltip>
    <Modal id="myModal"
    size="xl"
                isOpen={modal_standard}
                toggle={() => {
                    pythoncode_Modal();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        pythoncode_Modal();
                    }}>

                    View Python Code
                </ModalHeader>
                <ModalBody>
                    <PythonEditor code={code} />
                </ModalBody>
                <div className="modal-footer">
                    <Button
                        color="light"
                        onClick={() => {
                            pythoncode_Modal();
                        }}
                    >
                        Close
                    </Button>
                    {/* <Button
                        color="primary"
                    >
                        Save 
                    </Button> */}
                </div>
            </Modal>
    </>
  )
}

export default PythonEditor_Modal